<template>
  <div class="sc2" :class="{ 'sc2--online': card.bookOnline }">

    <div class="sc2__image">
      <img class="sc2__cover" :src="card.coverImage" :alt="card.name" />
      <img v-if="card.domainLabel" :src="card.domainLabel" alt="" class="sc2__label" />
    </div>

    <div class="sc2__body">

      <div class="sc2__header">
        <a :href="this.store.generateDomainUrl(card.slug)" class="sc2__title-link">
          <h4 class="sc2__title">{{ card.name }}</h4>
        </a>
        <div class="sc2__meta">
          <a href="#" class="sc2__location" @click.prevent="showOnMap">
            <i class="icon-location"></i> <span>{{ card.city }}</span>
          </a>
          <span v-if="card.bookOnline" class="sc2__badge sc2__badge--online">
            {{ vueTranslator('common.book_online') }}
          </span>
          <span v-else class="sc2__badge sc2__badge--operator">
            {{ vueTranslator('common.via_operator') }}
          </span>
        </div>
      </div>

      <div v-if="renderDescription" class="sc2__description">{{ renderDescription }}</div>

      <div class="sc2__units">
        <a
          v-for="unit in card.units"
          :key="unit.id"
          :href="this.store.generateAccommodationUrl(unit.slug)"
          class="sc2__unit"
        >
          <div class="sc2__unit-row">
            <div class="sc2__unit-name">
              <i v-if="unit.combination" class="icon-combo sc2__combo-icon"></i>
              <span>{{ unit.name }}</span>
            </div>
            <i class="icon-arrow-right sc2__arrow">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </div>

          <div class="sc2__stats">
            <div class="sc2__stats-caps">
              <span class="sc2__stat tooltip" :data-tooltip="vueTranslator('common.capacities.total_capacity')">
                <i class="icon-people"></i>{{ unit.totalCapacity }}
              </span>
              <span class="sc2__stat tooltip" :data-tooltip="vueTranslator('common.capacities.beds')">
                <i class="icon-bed"></i>{{ unit.bedsCapacity }}
              </span>
              <span class="sc2__stat tooltip" :data-tooltip="vueTranslator('common.capacities.own_beds')">
                <i class="icon-sleeping-bag"></i>{{ unit.ownBedsCapacity }}
              </span>
              <span v-if="unit.tentCapacity" class="sc2__stat tooltip" :data-tooltip="vueTranslator('common.capacities.max_capacity_in_tent')">
                <i class="icon-tent"></i>{{ unit.tentCapacity }}
              </span>
            </div>
            <div class="sc2__stats-price">
              <div
                v-for="price in unit.fromPrices"
                :key="price.mealType"
                class="sc2__price"
              >
                <i :class="{ 'icon-stove': price.mealType === 'self_cooking', 'icon-meal': price.mealType === 'full_board' }" class="sc2__price-icon tooltip" :data-tooltip="vueTranslator(`common.${price.mealType}`)"></i>
                <div class="sc2__price-info">
                  <span class="sc2__price-amount">{{ vueTranslator('common.price_from') }} €{{ toCurrency(price.amount) }}</span>
                  <span class="sc2__price-type">
                    <template v-if="price.mealType === 'self_cooking' && price.priceType === 'per_night'">{{ vueTranslator('common.price_types.per_night') }}</template>
                    <template v-if="price.mealType === 'self_cooking' && price.priceType === 'per_person_per_night'">{{ vueTranslator('common.price_types.per_person_per_night') }}</template>
                    <template v-if="price.mealType === 'full_board'">{{ vueTranslator('common.price_types.per_person_per_stay') }}</template>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>

    </div>

<div v-if="store.showLoader" class="sc2__loader">
      <Loader />
    </div>

  </div>
</template>

<script>
import { store } from "../../../store";
import { vueTranslator } from '../../../mixins.js';
import Loader from "../../Loader";

export default {
  name: "SearchCardV2",
  components: { Loader },
  props: {
    result: {},
  },
  data() {
    return {
      store,
      vueTranslator,
    }
  },
  computed: {
    renderDescription() {
      if (!this.result.description) return '';
      const div = document.createElement('div');
      div.innerHTML = this.result.description;

      return (div.textContent || div.innerText || '').trim();
    },
    card() {
      const r = this.result;
      return {
        name: r.name,
        slug: r.slug,
        city: r.address?.city,
        coverImage: r.cover_image,
        domainLabel: r.domain_label,
        bookOnline: r.book_online,
        description: r.description,
        units: (r.accommodations || []).map(a => ({
          id: a.id,
          slug: a.slug,
          name: a.name,
          combination: a.combination,
          totalCapacity: a.total_capacity,
          bedsCapacity: a.beds_capacity,
          ownBedsCapacity: a.own_beds_capacity,
          tentCapacity: a.tent_capacity,
          fromPrices: (a.from_prices || []).map(p => ({
            mealType: p.meal_type,
            priceType: p.price_type,
            amount: p.amount,
          })),
        })),
      };
    },
  },
  methods: {
    showOnMap() {
      this.$emit('update-view-mode-with-focus', this.result);
    },
    toCurrency(value) {
      let val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
}
</script>
